import inView from 'in-view';
import _debounce from 'lodash.debounce';

const header = document.querySelector('.header');
const menu = document.querySelector('.nav-menu');
const sections = document.querySelectorAll('.section');

function init() {
  inView.offset(50);

  inView('.intro')
    .on('enter', () => {
      toggleSticky(false);
    })
    .on('exit', () => {
      toggleSticky(true);
    });

  inView('.intro').check();

  const debouncedScroll = _debounce(onScroll, 50);
  document.addEventListener('scroll', debouncedScroll);
};

function toggleSticky(isFixed) {
  isFixed ? header.classList.add('sticky') : header.classList.remove('sticky');
  isFixed ? menu.classList.add('visible') : menu.classList.remove('visible');
}

function onScroll() {
  const firstMatch = [].find.call(sections, (el, i) => {
    inView.offset(100);
    return inView.is(el);
  });

  if(!firstMatch) {
    return menu.classList.remove('active');
  }

  let elId = firstMatch.getAttribute('id');

  elId = elId ? elId.replace('-section', '') : null;



  const aNavs = document.querySelectorAll('.nav-menu a');

  [].forEach.call(aNavs, a => {
    a.getAttribute('href') === `#${elId}` ? a.classList.add('active') : a.classList.remove('active');
  });

  menu.classList.add('active');
}

module.exports = {
  init
}



// WEBPACK FOOTER //
// ./src/header.js